export default __webpack_public_path__ + "static/media/MultipleChoice.d1abc4c9.svg";